function itemActivator() {
  $(".an-node-list-container").not(".show").find(".an-node-link").removeClass("active");
}



// WEBPACK FOOTER //
// ./skippair.github.io/assets/js/content/asideNav.js